import Popover from 'bootstrap/js/dist/popover';
/* global preloader, PhotoSwipe, PhotoSwipeLightbox: false */

$(function() {

	'use strict';

	$(window).resize(function() {


	});

	$(window).scroll(function() {


	});

	$(window).on('resize orientationchange scroll', function() {

		scrolledWindow();

	});

});

$(window).on('load', function () {
	'use strict';

	const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
	popoverTriggerList.forEach(function(popoverTriggerEl) {
		new Popover(popoverTriggerEl);
	});

});

(function($) {
	'use strict';

	/**
	 * Webhotelier Form Function
	 *
	 * @param options
	 */
	$.fn.webhotelierForm = function(options) {
		let el = $(this);

		let settings = $.extend({
			'split_dates': el.data('split_dates'),
			'icon_date': el.data('icon_date'),
		}, options);

		function getField(id) {
			let fieldEl = $('#' + id + '-picker');
			return fieldEl.length ? fieldEl : null;
		}

		function pickerSetup(id, date) {
			let el = getField(id);

			if (el !== null) {
				let checkin = (id === "checkin");

				el.datepicker({
					altField: el.get(0).form[id],
					altFormat: "yy-mm-dd",
					numberOfMonths: 2,
					defaultDate: "+0",
					changeMonth: true,
					changeYear: true,
					dateFormat: "dd/M/y",
					mandatory: true,
					showButtonPanel: true,
					firstDay: 1,
					minDate: checkin ? 0 : 1,
					maxDate: "+2y",
					showAnim: 'slideDown',
					showOn: settings.icon_date ? "button" : "focus",
					buttonImage: settings.icon_date ? settings.icon_date : "",
					buttonImageOnly: settings.icon_date ? "true" : "false",
					buttonText: "Select date",

					onSelect: function (dateText, inst) {
						let splitDateFormat = inst.settings.dateFormat.split(" ");
						if (checkin && getField("checkout") !== null) {

							// Change minimum date of checkout field to checkin + 1
							let constraint = new Date(el.datepicker("getDate"));
							constraint.setDate(constraint.getDate() + 1);
							getField("checkout").datepicker("option", "minDate", constraint);

							if (settings.split_dates) {
								// update visible Fields
								let d = $.datepicker.parseDate(inst.settings.dateFormat, dateText);

								$("." + id + "-date-day").text($.datepicker.formatDate(splitDateFormat[0], d));
								$("." + id + "-date-month").text($.datepicker.formatDate(splitDateFormat[1], d));
								$("." + id + "-date-year").text($.datepicker.formatDate(splitDateFormat[2], d));

								$(".checkout-date-day").text($.datepicker.formatDate("dd", constraint));
								$(".checkout-date-month").text($.datepicker.formatDate("M", constraint));
								$(".checkout-date-year").text($.datepicker.formatDate("y", constraint));
							}
						}
						if (settings.split_dates) {
							if (id === "checkout") {
								// update visible Fields
								let t = $.datepicker.parseDate(inst.settings.dateFormat, dateText);
								$("." + id + "-date-day").text($.datepicker.formatDate("dd", t));
								$("." + id + "-date-month").text($.datepicker.formatDate("M", t));
								$("." + id + "-date-year").text($.datepicker.formatDate("y", t));

							}
						}
					},

					onClose: function (selectedDate, inst) {
						// Set next day date to checkout field
						if (selectedDate) {
							let nextDay = $.datepicker.parseDate(inst.settings.dateFormat, selectedDate );

							nextDay.setDate(nextDay.getDate() + 1);

							let checkoutEl = $("input[name='checkout']");
							if (checkoutEl.length > 1 && getField("checkout") !== null) {
								getField("checkout").datepicker("option", "minDate", nextDay);
							}
						}
						// Fill out nights input
						let nightsEl = $("input[name='nights']");
						if (nightsEl.length > 1 && getField("checkout") !== null) {
							let datesDiff = Math.abs($("input[name='checkout']").val().getTime() - $("input[name='checkin']").val().getTime());
							let nights = Math.ceil(datesDiff / (1000 * 3600 * 24) );
							nightsEl.val(nights);
						}

					}

				});

				el.datepicker("setDate", date);

			}

			if (settings.split_dates) {
				$("." + id + "-date").on("click", function () {
					$("#" + id + "-picker").datepicker("show");
				});
			}

		}

		pickerSetup("checkin", "+0");
		pickerSetup("checkout", "+1");

	};

	/**
	 * Fixed on scroll
	 */
	$.fn.fixedOnScroll = function() {
		let fixedEl = $(this),
			pos = fixedEl.position(),
			fixedElMaxPosEl = $(fixedEl.attr("data-max-pos-element"));

		if (fixedElMaxPosEl.length > 0) {

			let fixedElMaxPos = fixedElMaxPosEl.position();
			let fixedElHeight = fixedEl.innerHeight();

			$(window).scroll(function() {
				let windowPos = $(window).scrollTop;

				if (windowPos >= pos.top - fixedElHeight && windowPos <= fixedElMaxPos.top) {
					fixedEl.addClass("fixed-top");
				} else {
					fixedEl.removeClass("fixed-top");
				}
			});

		} else {

			$(window).scroll(function() {
				let windowPos = $(window).scrollTop;

				if (windowPos >= pos.top) {
					fixedEl.addClass("fixed-top");
				}
			});

		}
	};

	/**
	 * Photoswipe Lightbox
	 *
	 * @param options
	 */
	$.fn.photoswipeLightbox = function(options) {
		let el = $(this);

		let settings = $.extend({
			bgOpacity: 0.7,
			closeOnScroll: true,
			escKey: true,
			arrowKeys: true,
			loop: true,
			history: true,
			focus: true,
			modal: true,
			showHideOpacity: true,
			closeEl: true,
			captionEl: true,
			fullscreenEl: true,
			zoomEl: true,
			shareEl: true,
			counterEl: true,
			arrowEl: true,
			preloaderEl: true,
		}, options);

		el.each( function() {
			let options = {
				bgOpacity: settings.bgOpacity,
				spacing: 0.12,
				allowPanToNext: true,
				pinchToClose: true,
				closeOnScroll: settings.closeOnScroll,
				closeOnVerticalDrag: true,
				escKey: settings.escKey,
				arrowKeys: settings.arrowKeys,
				history: settings.history,
				mouseUsed: false,
				loop: settings.loop,
				focus: settings.focus,
				modal: settings.modal,
				showHideOpacity: settings.showHideOpacity,
				showAnimationDuration: 333,
				hideAnimationDuration: 333,
				closeEl: settings.closeEl,
				captionEl: settings.captionEl,
				fullscreenEl: settings.fullscreenEl,
				zoomEl:  settings.zoomEl,
				shareEl:  settings.shareEl,
				counterEl: settings.counterEl,
				arrowEl: settings.arrowEl,
				preloaderEl:  settings.preloaderEl,
			};

			// Initialize PhotoSwipe
			let lightBox = new PhotoSwipeLightbox({
				gallery: `#${el.attr('id')}`,
				children: 'a',
				pswpModule: PhotoSwipe,
				options,
			});

			lightBox.init();

		});
	};

})(jQuery);

function scrolledWindow() {

    "use strict";
    let body = $("body");

    let scroll = $(window).scrollTop();

    if (scroll >= 500 || window.innerWidth < 992) {
        body.addClass("scrolled");
    } else {
        body.removeClass("scrolled");
    }

}

$( document ).ready( function() {

    "use strict";

    let body = $("body");
    let navbarNavDropdown = $("#navbarNavDropdown");
    let wrapperMenuSecondary = $("#wrapper-menu-secondary");
    let menuSecondary = $("#wrapper-menu-secondary .secondary-menu");

    scrolledWindow();

    /**
     * Menu
     */
	navbarNavDropdown.on('show.bs.collapse', function () {
        body.addClass("menu-opened");
    }).on('hide.bs.collapse', function () {
        body.removeClass("menu-opened");
		wrapperMenuSecondary.removeClass("active");
		wrapperMenuSecondary.find('.menu-item').removeClass('active');
    });
    $('.primary-menu .nav-link').on("mouseover", function() {
		if ($(this).hasClass('menu-item-has-children')) {
			wrapperMenuSecondary.addClass('active');
			wrapperMenuSecondary.find('.menu-item').removeClass('active');
			wrapperMenuSecondary.find('.menu-item').css('transition-delay', '0s');
			let menuClasses = $(this).attr("class").split(/\s+/);
			menuClasses.forEach(function(item) {
				if (item.indexOf('parent-page-item-') !== -1) {
					let childClass = '.child-page-item-' + item.replace('parent-page-item-', '');
					let allChildElements = $(wrapperMenuSecondary.find( childClass ));
					allChildElements.each( function(index, el) {
						$(el).addClass('active');
						$(el).css('transition-delay', (index + 1) * 0.1 + 's');
					});
				}
			});
		} else {
			wrapperMenuSecondary.removeClass('active');
		}
		if ($(this).hasClass('parent-page-item-accommodation')) {
			menuSecondary.addClass('columns-2');
		} else {
			menuSecondary.removeClass('columns-2');
		}
    });

    /**
     * Fixed on scroll navbar
     */
    let $fixedOnScroll = $('[data-fixed-on-scroll]');
    if ($fixedOnScroll.length > 0 && window.innerWidth > 992) {
        $fixedOnScroll.each(function() {
            $(this).fixedOnScroll();
        });
    }

    /**
     * Webhotelier Form
     */
    let $webhotelierForm = $('#webhotelier-form');
    if ($webhotelierForm.length > 0 ) {
        $webhotelierForm.webhotelierForm( $webhotelierForm.data( 'json' ) );
    }

    /**
     * Slick Slider
     */
    let slickEl = $("*[data-slick]");
    if (slickEl.length > 0) {
        slickEl.each(function() {
            let slickElement = $(this);
            slickElement.slick({
                prevArrow: '<button type="button" class="slick-svg-prev"><p class="sr-only screen-reader-text">Altana slider</p><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 12.03"><path d="M.28 6.66l5.22 5.1a.94.94 0 0 0 1.32 0 .9.9 0 0 0 0-1.28L3.17 6.92H17.1a.91.91 0 1 0 0-1.82H3.18l3.64-3.55a.88.88 0 0 0 0-1.28.93.93 0 0 0-1.31 0L.28 5.37A.9.9 0 0 0 .01 6a.87.87 0 0 0 .27.65z"/></svg></button>',
                nextArrow: '<button type="button" class="slick-svg-next"><p class="sr-only screen-reader-text">Altana slider</p><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 12.03"><path d="M17.74 5.37L12.52.27a.94.94 0 0 0-1.32 0 .9.9 0 0 0 0 1.28l3.65 3.56H.92a.91.91 0 1 0 0 1.82h13.92l-3.64 3.55a.88.88 0 0 0 0 1.28.93.93 0 0 0 1.31 0l5.23-5.1a.9.9 0 0 0 .27-.64.87.87 0 0 0-.27-.65z"/></svg></button>',
            });
        });
    }

    /**
     * First Slideshow
     */
    let $firstSlideshow = $('.first-slideshow');
    if ($firstSlideshow.length > 0) {
        $firstSlideshow.on( 'change.flickity', function( event, index ) {
            if (0 === index) {
                $('.first-slideshow-slogan-title, .first-slideshow-slogan-subtitle').removeClass('text-white');
            } else {
                $('.first-slideshow-slogan-title, .first-slideshow-slogan-subtitle').addClass('text-white');
            }
        });

		$firstSlideshow.on( 'select.flickity', onSelect );
    }

	function onSelect() {
		let flkty = $firstSlideshow.data('flickity');
		if ( flkty.player.state !== 'playing' ) {
			disableAutoplay();
			return;
		}

		let isAtLast = flkty.selectedIndex === flkty.slides.length - 1;
		if ( isAtLast  ) {
			disableAutoplay();
		}
	}

	function disableAutoplay() {
		$firstSlideshow.flickity('stopPlayer');
		$firstSlideshow.off( 'select.flickity', onSelect );
	}

    /**
     * Masonry Gallery
     */
    let $gallery = $(".masonry-gallery");
    if ($gallery.length > 0) {

        if ($gallery.data("isotope")) {
            /**
             * init Isotope after all images have loaded
             */
            $gallery.imagesLoaded().progress( function() {
                $gallery.isotope('layout');
            });

            /**
             * Filter items on button click
             */
            $(".masonry-gallery-filters").on('click', 'li a', function() {

				$gallery.find('.gallery-item').preloader({
					loader: '/app/themes/nelios-base/svg/loader/preloader.svg',
					fadeIn: 300,
					delay: 100
				});

                $gallery.isotope({
                    filter: $(this).attr('data-filter')
                });
            });
        } else if ($gallery.data('masonry')) {
            $gallery.imagesLoaded().progress( function() {
                $gallery.masonry('layout');
            });
        }

        if ($gallery.data('photoswipe-options')) {
            $gallery.photoswipeLightbox($gallery.data('photoswipe-options'));
			console.log($gallery);
            /**
             * Lightbox All Link
             */
			$gallery.parent().on('click', '.masonry-gallery-all-link', function(event) {
                event.preventDefault();

                if (typeof preloader === 'function') {
                    $gallery.find('.gallery-item').preloader({
						loader: '/app/themes/nelios-base/svg/loader/preloader.svg',
                        fadeIn: 300,
                        delay: 100
                    });
                }
                $gallery.find('.gallery-item.d-none').removeClass('d-none');
                $(this).hide();
                $gallery.masonry('layout');
            });
        }

    }

    /**
     * Google Map
     */
    let $map = $('.map');
    if ($map.length > 0) {
        let elMap = $map;
        elMap.googleMap(elMap.data("json"));
    }

    /**
     *  Scroll To Content Button
     */
    let scrollDown = $(".scroll-down");
    let navbarWrapper = $("#wrapper-navbar");
    let pageWrapper = $("#content");
    if (scrollDown.length > 0 && navbarWrapper.length > 0 && pageWrapper.length > 0) {
        scrollDown.on('click', function(e) {
            e.preventDefault();

            let offset = ( navbarWrapper.length > 0 ) ? navbarWrapper.height() : 0;

            $('html, body').animate({
                scrollTop: pageWrapper.offset().top - offset
            }, 500);
        });
    }
});



